import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  nSites: '{count} Sites',
  nDevices: '{count} Devices',
  n1Device: '1 Device',
  placeholder: 'Site or Device',
  queryPlaceholder: 'Search Sites or Device Name',
})
